import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../environments/environment";
import { Observable } from "rxjs";
import { dataType } from "./dataType";

@Injectable({
  providedIn: "root"
})
export class AuthService {
  serviceUrl;

  // private loginStatus = JSON.parse(localStorage.getItem('loggedIn') || 'false')  // for route guard
  private loginStatus = false;
  constructor(private http: HttpClient) {
    this.serviceUrl = environment.serviceUrl;
  }

  setLoggedIn(status: boolean, token: Object) {
    //for route guard
    this.loginStatus = status;
    localStorage.setItem("loggedIn", "true");
    localStorage.setItem("token", JSON.stringify(token));
  }

  get isLoggedIn() {
    // const auth_token=localStorage.getItem('token')                                 //for route guard
    // this.http.get<checkData>(this.serviceUrl+'/authValidation',
    //                           {
    //                             headers: new HttpHeaders().set('Authorization',auth_token)
    //                           }).subscribe(res=>{
    //                             return res
    //                           })
    // console.log(isValid)
    return this.loginStatus;
    // return JSON.parse(localStorage.getItem('loggedIn') || this.loginStatus.toString())
  }

  userLogin(user) {
    //login
    //get user auth details

    const userdata = { payload: user };
    console.log(userdata);

    return this.http.post<dataType>(this.serviceUrl + "/userLogin", userdata);
  }

  userLogout(data): Observable<dataType> {
    const auth_token = localStorage.getItem("token");
    return this.http.post<dataType>(this.serviceUrl + "/userLogout", data, {
      headers: new HttpHeaders().set("Authorization", auth_token)
    });
  }

  requestOtp(user) {
    //forgot password
    //password recovery
    const userdata = { payload: user };
    return this.http.post<dataType>(
      this.serviceUrl + "/forgotPassword",
      userdata
    );
  }
  setNewPassword(user) {
    const userdata = { payload: user };
    return this.http.post<dataType>(
      this.serviceUrl + "/confirmPassword",
      userdata
    );
  }

  validateUser(): Observable<dataType> {
    const auth_token = localStorage.getItem("token");
    return this.http.get<dataType>(this.serviceUrl + "/authValidation",{
      headers: new HttpHeaders().set(
        "Authorization",
        JSON.parse(auth_token).accessToken.jwtToken
      )
    });
  }

  changePassword(user) {
    //login
    //get user auth details

    const userdata = { payload: user };
    console.log(userdata);
    const auth_token = localStorage.getItem("token");
    return this.http.post<dataType>(
      this.serviceUrl + "/changePassword",
      userdata,
      {
        headers: new HttpHeaders().set("Authorization", auth_token)
      }
    );
  }

  signupUser(data) {
    console.log(data);
    return this.http.post<dataType>(this.serviceUrl + "/signup", data);
  }

  confirmUser(data){
    console.log(data)
    return this.http.post<dataType>(this.serviceUrl+"/confirmUser",data)
  }
}
